// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { tbmApi } from '../apis/tbm.api';

// actions
import { actions } from '../actions/tbm.action';

// models
import { ReqTbmAttendance, ReqTbmStatusList, ResTbmAttendance, ResTbmDetail, ResTbmStatusList, TbmAttendanceObject, TbmDetailObject } from '../models/tbm.model';

/**
 * TBM 상태 목록 조회
 */
export const getTbmStatusList = createAsyncThunk(
  actions.GET_TBM_STATUS_LIST,
  async (data: ReqTbmStatusList, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res : ResTbmStatusList = await tbmApi.getTbmStatusList(data);
      
      return fulfillWithValue({
        ...res
      } as ResTbmStatusList);
    } catch (error) {
      return rejectWithValue(error);
    }
});

/**
 * TBM 상세 조회
 * @param {string} tbmId
 * @returns {TbmDetailObject}
 */
export const getTbmDetail = createAsyncThunk(
  actions.GET_TBM_DETAIL,
  async (tbmId: string, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res : ResTbmDetail = await tbmApi.getTbmDetail(tbmId);

      return fulfillWithValue({...res.resultObject as TbmDetailObject});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * TBM 파일 조회
 */
export const getTbmFile = createAsyncThunk(
  actions.GET_TBM_FILE,
  async (fileId: string, { fulfillWithValue, rejectWithValue }) => {
    if(!fileId){
      return null;
    }
    try {
      
      const fileUrl = await tbmApi.getTbmFile(fileId);
      return fulfillWithValue({
        id: fileId,
        url: fileUrl as string
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


/**
 * TBM 참여자 조회
 * @param {ReqTbmAttendance} data
 * @returns {TbmAttendanceObject[]}
 */
export const getTbmAttendance = createAsyncThunk(
  actions.GET_TBM_ATTENDANCE,
  async (data: ReqTbmAttendance, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res : ResTbmAttendance = await tbmApi.getTbmAttendance(data);
      return fulfillWithValue({
        ...res
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
